// extracted by mini-css-extract-plugin
export default {"loadingDisplay":"LoadingDisplay_loadingDisplay__YASLQ","icon":"LoadingDisplay_icon__2BJsL","spin":"LoadingDisplay_spin__6uQvx","label":"LoadingDisplay_label__LPiXJ"};